import { memo, ReactNode } from 'react';

import { is } from 'helpers/ramda';

interface RenderProps {
  when: ((props: RenderProps) => boolean) | boolean;
  children: ReactNode;
  else?: ((props: RenderProps) => ReactNode) | ReactNode;
}

const getResult = <T>(key: ((props: RenderProps) => T) | T, props: RenderProps): T => {
  return is(Function, key) ? key(props) : key;
};

const Render = memo((props: RenderProps) => {
  const { when, children, else: Else } = props;
  return getResult(when, props) ? children : getResult(Else, props);
});

Render.displayName = 'Render';

export default Render;
